import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-teal text-white text-center py-3">
      <div className="container">
        <small>&copy;  {new Date().getFullYear()} Vakralabs Services. All rights reserved.</small>

        <a href="/terms-and-conditions" className="text-white mx-2" style={{ textDecoration: 'underline' }}>Terms & Conditions</a>
        |

        <a href="/cancellation-and-refund-policy" className="text-white mx-2" style={{ textDecoration: 'underline' }}>Cancellation & Refund Policy</a>
      </div>
    </footer>
  );
};

export default Footer;